import {
    type DefineFilterInput,
    defineFilter,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filters-registry/defineFilter";

import type { LeadsCapability } from "../types/leadsCapability";
import type { ApiCategoryOf, StaticLeadsFilterKey } from "../types/leadsFilterApiCategory";
import type { LeadsDataSource, LeadsFilterBuildContext } from "../types/leadsFilterBuildContext";
import type { LeadsFilterDefinition } from "../types/leadsFilterDefinition";
import type { LeadsSearchAllFiltersTypes } from "../types/leadsSearchFilters.dto";

export type DefineLeadsFilterInput<K extends StaticLeadsFilterKey> = DefineFilterInput<
    LeadsSearchAllFiltersTypes,
    ApiCategoryOf<K>,
    LeadsFilterBuildContext,
    LeadsDataSource,
    LeadsCapability,
    K
>;

/** Leads binding of `defineFilter`: `apiCategory` is pinned to the static table, so it can't drift. */
export const defineLeadsFilter = <K extends StaticLeadsFilterKey>(
    input: DefineLeadsFilterInput<K>,
): LeadsFilterDefinition<K> => defineFilter(input);
